export default __webpack_public_path__ + "static/media/Userlist.40392ec3.svg";